import React, { useState, useEffect } from "react";
import { Grid, Divider, Button, Header } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { MdDeleteForever } from "react-icons/md";
import { FaEdit } from "react-icons/fa";

const DataInvIndiaList = (props) => {
  const navigate = useNavigate();
  const [rowData, setrowData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [gridApi, setGridApi] = useState(null);

  const { visaCategoryId } = props;

  useEffect(() => {
    getWorkCatList();
  }, []);

  const getWorkCatList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listDataEntry", {
        categoryId: visaCategoryId,
        getAll: visaCategoryId === 0 ? true : false,
        dataEntryId: 1,
      })
      .then((res) => {
        setrowData(res.data);
      })
      .catch((error) => console.log(error));
  };

  const columnDefs = [
    {
      headerName: "Select All",
      headerCheckboxSelection: true, // Enable header checkbox
      headerCheckboxSelectionFilteredOnly: true, // Only select filtered rows
      checkboxSelection: true,
      flex: 0.5,
    },
    { headerName: "Date", field: "entryDate", flex: 1.5 },
    { headerName: "Name", field: "name", flex: 3 },
    { headerName: "Description", field: "description", flex: 2 },
    { headerName: "Item", field: "item", flex: 2 },
    { headerName: "Tickettype", field: "ticketType", flex: 2 },
    { headerName: "AED", field: "aed", flex: 1 },
    { headerName: "Quantity", field: "quantity", flex: 1 },
    { headerName: "UnitPrice", field: "unitPrice", flex: 1 },
    { headerName: "Discount", field: "discount", flex: 1 },
    { headerName: "Total", field: "total", flex: 1 },
    { headerName: "Remarks", field: "remarks", flex: 2 },
    {
      headerName: "Action",
      field: "categoryId",
      flex: 1.5,
      cellRendererFramework: (params) => (
        <div>
          <Button color="primary" onClick={() => actionButton(params)}>
            <FaEdit />
          </Button>{" "}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Button color="red" onClick={() => deleteItem(params)}>
            <MdDeleteForever />
          </Button>
        </div>
      ),
    },
  ];

  const actionButton = (params) => {
    navigate(
      `/data-inv-india-new-create/${params.data.dataEntryId}/${visaCategoryId}`
    );
  };

  const deleteItem = (params) => {
    // Implement delete functionality
  };

  const defaultColDef = {
    sortable: true,
    editable: true,
    flex: 1,
    filter: true,
    floatingFilter: true,
  };

  const onSelectionChanged = () => {
    const selectedNodes = gridApi.getSelectedNodes();
    const newSelectedRows = selectedNodes.map((node) => {
      const selectedRow = {};

      columnDefs.forEach((column) => {
        const fieldName = column.field;
        if (fieldName !== "checkbox" && fieldName !== "categoryId") {
          selectedRow[fieldName] = node.data[fieldName];
        }
      });

      return selectedRow;
    });

    const updatedSelectedRows = [...selectedRows, ...newSelectedRows];
    const uniqueSelectedRows = Array.from(
      new Set(updatedSelectedRows.map((row) => JSON.stringify(row)))
    ).map((row) => JSON.parse(row));
    setSelectedRows(uniqueSelectedRows);
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    params.api.sizeColumnsToFit();
  };

  const exportToCSV = (fileName) => {
    if (selectedRows.length === 0) {
      Swal.fire(
        "No rows selected!",
        "Please select rows to export.",
        "warning"
      );
      return;
    }

    const ws = XLSX.utils.json_to_sheet(selectedRows);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    FileSaver.saveAs(data, fileName + ".xlsx");
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Data Entry List
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Button
          type="submit"
          primary
          onClick={() =>
            navigate(`/data-inv-india-new-create/null/${visaCategoryId}`)
          }
        >
          Create New
        </Button>
        {selectedRows.length > 0 && (
          <Button color="primary" onClick={() => exportToCSV("Data_list")}>
            Download CSV
          </Button>
        )}
      </Grid.Row>
      <Divider hidden /> <Divider />
      <div className="ag-theme-alpine" style={{ height: 600 }}>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          pagination={true}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          rowSelection={"multiple"}
          suppressRowClickSelection={true}
        />
      </div>
    </div>
  );
};

export default DataInvIndiaList;
